import { BillingCurrentPricePlanViewModelQuery } from '@shared/api/graphql/generated';

type OrganizationPricePlanResult = NonNullable<
  BillingCurrentPricePlanViewModelQuery['organizationCurrentPricePlanQuery']
>;

type PricePlanData = OrganizationPricePlanResult & {
  pricePlan: NonNullable<OrganizationPricePlanResult['pricePlan']>;
  pricePlanPeriod: NonNullable<OrganizationPricePlanResult['pricePlanPeriod']>;
};

export type CurrentPricePlanBillingData = {
  companyBillingInfoQuery: NonNullable<BillingCurrentPricePlanViewModelQuery['companyBillingInfoQuery']>;
  organizationCurrentPricePlanQuery: PricePlanData;
  acceptanceAdvancedQuery: BillingCurrentPricePlanViewModelQuery['acceptanceAdvancedQuery'];
};

export const isCurrentPricePlanBillingDataValid = (
  data?: BillingCurrentPricePlanViewModelQuery
): data is CurrentPricePlanBillingData => {
  if (!data?.companyBillingInfoQuery) return false;

  const pricePlanData = data.organizationCurrentPricePlanQuery;

  if (!pricePlanData) return false;

  return !!pricePlanData.pricePlan && !!pricePlanData.pricePlanPeriod;
};
